"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { Poll } from "../ui/Poll";
import ProgressBar from "../ui/ProgressBar";
export default function PollResult() {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      question: "\u0B95\u0BB0\u0BCD\u0BA8\u0BBE\u0B9F\u0B95 \u0BA4\u0BC7\u0BB0\u0BCD\u0BA4\u0BB2\u0BC1\u0B95\u0BCD\u0B95\u0BBE\u0BA9 \u0B86\u0B95\u0BCD\u0B9A\u0BBF\u0BB8\u0BCD \u0BAE\u0BC8 \u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE \u0B95\u0BB0\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BCD\u0B95\u0BA3\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1 \u0B95\u0BA3\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1. \u0B95\u0BB0\u0BCD\u0BA8\u0BBE\u0B9F\u0B95 \u0BA4\u0BC7\u0BB0\u0BCD\u0BA4\u0BB2\u0BC1\u0B95\u0BCD\u0B95\u0BBE\u0BA9 \u0B86\u0B95\u0BCD\u0B9A\u0BBF\u0BB8\u0BCD \u0BAE\u0BC8 \u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE \u0B95\u0BB0\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BCD\u0B95\u0BA3\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1 \u0B95\u0BA3\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1",
      options: [{
        text: "\u0BAE\u0BC1\u0BB4\u0BC1\u0BAE\u0BC8\u0BAF\u0BBE\u0B95 \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0B95\u0BC6\u0BBE\u0BB3\u0BCD\u0B95\u0BBF\u0BB1\u0BC7\u0BA9\u0BCD",
        percentage: 26
      }, {
        text: "\u0BAE\u0BC1\u0BB4\u0BC1\u0BAE\u0BC8\u0BAF\u0BBE\u0B95 \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0B95\u0BC6\u0BBE\u0BB3\u0BCD\u0B95\u0BBF\u0BB1\u0BC7\u0BA9\u0BCD",
        percentage: 66
      }, {
        text: "\u0BAE\u0BC1\u0BB4\u0BC1\u0BAE\u0BC8\u0BAF\u0BBE\u0B95 \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0B95\u0BC6\u0BBE\u0BB3\u0BCD\u0B95\u0BBF\u0BB1\u0BC7\u0BA9\u0BCD",
        percentage: 56
      }, {
        text: "\u0BAE\u0BC1\u0BB4\u0BC1\u0BAE\u0BC8\u0BAF\u0BBE\u0B95 \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0B95\u0BC6\u0BBE\u0BB3\u0BCD\u0B95\u0BBF\u0BB1\u0BC7\u0BA9\u0BCD",
        percentage: 46
      }]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [pollData] = useState(t0);
  pollData.options.reduce(_temp, pollData.options[0]);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex text-12-tamil-600  items-center inline-block rounded-lg"><Poll id="1" label="Thank you for your vote" bgColor="bg-00B812" textColor="text-FFFFFF" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== pollData.question) {
    t2 = <p className="text-14-tamil-700 mt-3 leading-[1.5] text-1B1B1B">{pollData.question}</p>;
    $[2] = pollData.question;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== pollData.options) {
    t3 = pollData.options.map(_temp2);
    $[4] = pollData.options;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 text-222222 text-12-tamil-400">{t3}</div>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className="w-full max-w-[884px] border border-DCDCDC p-5 bg-FFFFFF mx-auto bg-ECEEF3">{t1}{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp2(option_0, index) {
  return <div key={index} className="relative"><ProgressBar label={option_0.text} percentage={option_0.percentage} voteText={"\u0BB5\u0BBE\u0B95\u0BCD\u0B95\u0BC1"} className="w-full hover:shadow-sm transition-shadow" /></div>;
}
function _temp(max, option) {
  return option.percentage > (max?.percentage || 0) ? option : max;
}